/**
 * The translation namespaces every reports surface shares.
 *
 * These are spelled once here rather than per file: the reports list, the
 * expanded table and the recurring-schedules table each render the same
 * labels, and a namespace re-typed at each call site is a namespace that
 * drifts when the keys move.
 */
export const TRANSLATION_KEY = "chat.reports";

/** The expanded table's own keys, nested under the reports namespace. */
export const EXPANDED_TRANSLATION_KEY = `${TRANSLATION_KEY}.expanded`;

/** The row actions menu, which also passes this to the shared dropdown. */
export const ACTIONS_TRANSLATION_KEY = `${TRANSLATION_KEY}.actions`;

/**
 * The recurring-schedules table predates the reports tab and its keys live
 * under the schedule modal, which owns the schedules themselves.
 */
export const RECURRING_REPORTS_TRANSLATION_KEY =
  "chat.scheduleModal.recurringReports";

/**
 * The menu groups a report row's actions fall into, in the order the design
 * draws them. The menu derives its sections from this list, so a new group is
 * added in one place rather than declared once as a type and again as a
 * section the menu happens to render.
 */
export const REPORT_ACTION_GROUPS = [
  "primary",
  "manage",
  "destructive"
] as const;

export type ReportActionGroup = (typeof REPORT_ACTION_GROUPS)[number];
